import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore, authService } from '@features/auth'
import AppRouter from '@app/router'

function App() {
  const navigate = useNavigate()
  const { checkAuth, logout } = useAuthStore()

  useEffect(() => {
    const interceptorId = authService.setupInterceptors(() => {
      logout()
      navigate('/login')
    })
    checkAuth()
    return () => {
      authService.ejectInterceptor(interceptorId)
    }
  }, [checkAuth, logout, navigate])

  return <AppRouter />
}

export default App
